import { render, staticRenderFns } from "./PurchaseReceivingEdit.vue?vue&type=template&id=374e2cba&"
import script from "./PurchaseReceivingEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceivingEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReceivingEdit.vue?vue&type=style&index=0&id=374e2cba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports